import { useTranslation } from 'react-i18next';

const TONO: Record<string, string> = {
  ACTIVE: 'bueno',
  INVITED: 'aviso',
  SUSPENDED: 'critico',
  TERMINATED: 'critico',
};

/**
 * El estado nunca se comunica sólo con color: la píldora lleva siempre su texto,
 * y el punto de color es refuerzo, no la información.
 */
export function PildoraEstado({ estado }: { estado: string }) {
  const { t } = useTranslation();
  return (
    <span className={`pildora pildora--${TONO[estado] ?? 'neutro'}`}>
      <span className="pildora__punto" aria-hidden="true" />
      {t(`user.status.${estado}`)}
    </span>
  );
}
